<template>
  <transition name="fade">
    <div id="HyptoPopup" class="hypto-popup">
      <div class="popup-box" :class="css">
        <div class="heading" v-if="header">
          <h5 class="title">{{title}}</h5>
          <span class="close-button" @click="closePopup">&times;</span>
        </div>

        <div class="body">
          <slot name="body" />
        </div>

        <div class="footer" v-if="footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'HyptoPopup',
  props: {
    title: String,
    header: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true
    },
    css: {
      type: String
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.escPressed)
  },
  computed: {
    ...mapGetters(['getterPopupName'])
  },
  created () {
    document.addEventListener('keydown', this.escPressed)

    if (this.$analytics) {
      this.$analytics.logEvent('open_popup', {
        popup_name: this.getterPopupName
      })
    }
  },
  methods: {
    ...mapMutations(['SET_POPUP_NAME']),
    escPressed ($event) {
      if ($event.keyCode === 27) {
        this.closePopup()
      }
    },
    closePopup () {
      this.SET_POPUP_NAME(null)
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .hypto-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.6);
    z-index: 500;

    .popup-box {
      background: $white;
      border-radius: 10px;
      padding: 10px;

      .title {
        @include normal-text($secondary, 20px);
      }
      .heading {
        @include custom-flex(space-between);
        padding: 20px;
        width: 100%;
        border-bottom: 1px solid $grey-outline;
      }
      .close-button {
        @include normal-text($secondary, 24px, 500);
        cursor: pointer;
        padding: 4px;
      }

      .footer {
        @include custom-flex(space-evenly);
        padding: 20px;
        border-top: 1px solid $grey-outline;
      }
      .body {
        padding: 20px;
        max-height: 70vh;
        overflow: auto;
      }
    }
  }

  .desktop {
    .width-lg {
      width: 50% !important;
    }

    .popup-box {
      width: 35%;
      position: fixed;
      top: 5%;
      left: 50%;
      transform: translateX(-50%);

      .body {
        max-height: 75vh !important;
      }
    }
  }

  .mobile, .tablet {
    .hypto-popup {
      @include custom-flex();
    }

    .popup-box {
      width: 90%;

      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>

<style>
  .md-select-menu {
    z-index: 550 !important;
  }
</style>
